<template>
    <div>
        <div class="table-responsive" v-if="announcements.length">
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>{{ $t('pages.admin.livestream.announcements.model.title') }}</th>
                    <th>{{ $t('pages.admin.livestream.announcements.model.starts_at') }}</th>
                    <th>{{ $t('actions.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="announcement in announcements">
                    <td>
                        {{ announcement.title[$i18n.locale] }}
                    </td>
                    <td>
                        {{ $date(announcement.starts_at).format('DD.MM.YYYY HH:mm') }}
                    </td>
                    <td>
                        <router-link tag="button" class="btn btn-sm btn-outline-warning" :to="{name: 'admin.livestream.announcement.edit', params: {announcement: announcement.id}}">
                            <i class="mdi mdi-pencil"></i> {{ $t('actions.edit') }}
                        </router-link>
                        <button class="btn btn-sm btn-outline-danger" @click="selectedToDelete = announcement">
                            <i class="mdi mdi-trash-can"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <announcement-delete-modal :selected="selectedToDelete" @announcement-deleted="$emit('reload')"></announcement-delete-modal>
        </div>

        <div class="alert alert-secondary border-dark" v-if="!announcements.length && emptyText !== null">
            {{ emptyText }}
        </div>
    </div>
</template>

<script>
import DeleteConfirmation from "../../../../Includes/DeleteConfirmation";
import AnnouncementDeleteModal from "./AnnouncementDeleteModal";
export default {
    name: "AnnouncementTable",
    components: {AnnouncementDeleteModal, DeleteConfirmation},
    data: () => ({
        selectedToDelete: null,
    }),
    props: {
        announcements: {
            type: Array,
            required: true
        },
        emptyText: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped>

</style>
